import { Editor } from '@tiptap/react';
import React from 'react';

import { BoldIcons, ItalicIcons } from '../../../../../../../../icons/icons';
import {
  BlockQuoteIcon,
  BulletListIcon,
  H1Icon,
  H2Icon,
  H3Icon,
  HorizontalRuleIcon,
  OrderedListIcon,
  RedoIcon,
  UndoIcon,
} from '../../../../../../../../ui/icons/icons';
import { IconButton } from './IconButton';

interface EditorToolbarProps {
  editor: Editor | null;
}

const EditorToolbar: React.FC<EditorToolbarProps> = ({ editor }) => {
  if (!editor) {
    return null;
  }

  const BUTTON_DATA = [
    {
      action: 'bold',
      label: 'Bold',
      onClick: () => editor.chain().focus().toggleBold().run(),
      icon: <BoldIcons />,
    },
    {
      action: 'italic',
      label: 'Italic',
      onClick: () => editor.chain().focus().toggleItalic().run(),
      icon: <ItalicIcons />,
    },
    {
      action: 'h1',
      label: 'Heading 1',
      onClick: () => editor.chain().focus().toggleHeading({ level: 1 }).run(),
      icon: <H1Icon />,
    },
    {
      action: 'h2',
      label: 'Heading 2',
      onClick: () => editor.chain().focus().toggleHeading({ level: 2 }).run(),
      icon: <H2Icon />,
    },
    {
      action: 'h3',
      label: 'Heading 3',
      onClick: () => editor.chain().focus().toggleHeading({ level: 3 }).run(),
      icon: <H3Icon />,
    },
    {
      action: 'bullet-list',
      label: 'Bullet list',
      onClick: () => editor.chain().focus().toggleBulletList().run(),
      icon: <BulletListIcon />,
    },
    {
      action: 'ordered-list',
      label: 'Numbered list',
      onClick: () => editor.chain().focus().toggleOrderedList().run(),
      icon: <OrderedListIcon />,
    },
    {
      action: 'blockquote',
      label: 'Quote',
      onClick: () => editor.chain().focus().toggleBlockquote().run(),
      icon: <BlockQuoteIcon />,
    },
    {
      action: 'horizontal-rule',
      label: 'Divider',
      onClick: () => editor.chain().focus().setHorizontalRule().run(),
      icon: <HorizontalRuleIcon />,
    },
    {
      action: 'undo',
      label: 'Undo',
      onClick: () => editor.chain().focus().undo().run(),
      icon: <UndoIcon />,
    },
    {
      action: 'redo',
      label: 'Redo',
      onClick: () => editor.chain().focus().redo().run(),
      icon: <RedoIcon />,
    },
  ];

  return (
    <div className='mb-2 flex max-w-full gap-1 overflow-x-auto rounded-lg border border-slate-200 bg-slate-100 p-1 sm:flex-wrap sm:overflow-visible'>
      { BUTTON_DATA.map((button) => (
        <IconButton
            key={button.action}
            onClick={button.onClick}
            icon={button.icon}
            label={button.label}
        />
      )) }
    </div>
  );
};

export default EditorToolbar;
